'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'cow';
var width = 640;
var height = 512;
var aliases = [128004];
var unicode = 'f6c8';
var svgPathData = 'M128 144l0 264c0 4.4 3.6 8 8 8l32 0c4.4 0 8-3.6 8-8l0-72c0-53 43-96 96-96s96 43 96 96l0 72c0 4.4 3.6 8 8 8l32 0c4.4 0 8-3.6 8-8l0-168c0-5.5 2.9-10.7 7.6-13.6s10.6-3.2 15.6-.7l64 32c5.4 2.7 8.8 8.2 8.8 14.3l0 62.7c0 3 .9 6 2.5 8.6l37.3 58.6c5.6 8.8 15.3 14.1 25.7 14.1 16.8 0 30.5-13.6 30.5-30.5l0-87.5c0-3.3-1-6.4-2.8-9.1L594.8 274c-1.9-2.7-2.8-5.9-2.8-9.1l0-64.9c0-4.4-3.6-8-8-8-4 0-7.3 2.9-7.9 6.7-1.1 6.4-5.9 11.6-12.3 13s-12.9-1.1-16.7-6.5l-51.7-74.7C480.5 108.9 456 96 429.7 96l-30 0c-1.9 26.9-13.4 52.3-32.5 71.4l-3.1 3.1c-24 24-56.6 37.5-90.5 37.5l-3.2 0c-33.9 0-66.5-13.5-90.5-37.5l-3.1-3.1c-16.6-16.6-27.4-37.8-31.2-60.5-10.7 8.8-17.6 22.2-17.6 37.1zm71.4 .8l3.1 3.1c18 18 42.4 28.1 67.9 28.1l3.2 0c25.5 0 49.9-10.1 67.9-28.1l3.1-3.1c13.2-13.2 21.3-30.4 23.1-48.8L176.4 96c1.8 18.4 9.9 35.6 23.1 48.8zm8.6 231l0 32.2c0 22.1-17.9 40-40 40l-32 0c-22.1 0-40-17.9-40-40l0-264c0-18 6-34.6 16-48-26.5 0-48 21.5-48 48l0 124.8C64 297.1 41.1 320 12.8 320 5.7 320 0 314.3 0 307.2L0 288c0-23.7 12.9-44.4 32-55.4L32 144c0-44.2 35.8-80 80-80l317.7 0c36.8 0 71.2 18 92.1 48.2l38.5 55.6c6.6-4.9 14.9-7.8 23.7-7.8 22.1 0 40 17.9 40 40l0 59.9 7.5 10.8c5.6 8 8.5 17.6 8.5 27.3l0 87.5c0 34.5-28 62.5-62.5 62.5-21.4 0-41.2-10.9-52.7-28.9l-37.3-58.6c-4.9-7.7-7.5-16.6-7.5-25.8l0-52.8-32-16 0 142.1c0 22.1-17.9 40-40 40l-32 0c-22.1 0-40-17.9-40-40l0-32.2c-6.6 2-14.6 3.8-24 5.3l0 10.9c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8.1c-5.1 .1-10.9 .1-16 0l0 8.1c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-10.9c-9.4-1.5-17.4-3.3-24-5.3zm0-33.8c2.1 .8 4.7 1.8 7.7 2.7 11.4 3.5 29.8 7.3 56.3 7.3s44.9-3.8 56.3-7.3c3-.9 5.6-1.9 7.7-2.7l0-6c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 6zm344-22a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCow = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;